/** State of the extra-time badge:
 *  - `empty`  — no added time, nothing to send;
 *  - `staged` — the operator has staged a value but not sent it yet (a badge
 *               press is awaited);
 *  - `sent`   — the value is written, but the strip is not on air (the "Extra time"
 *               tile or the checkbox is awaited);
 *  - `live`   — the value is written and the strip is on air. */
export type ExtraBadgeState = "empty" | "staged" | "sent" | "live";

export function extraBadgeState(draft: number, live: number, onAir: boolean): ExtraBadgeState {
  if (draft !== live) return "staged";
  if (draft === 0) return "empty";
  return onAir ? "live" : "sent";
}
